export default __webpack_public_path__ + "static/media/00.9d6c4ee6.jpg";